var _rect, _g, _g2, _g3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 220",
    width: 800,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 220,
    rx: 16,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 68,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 34,
    fill: "#2563eb",
    fontWeight: 700
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 14,
    fill: "#35556b"
  }, "Connect"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 68,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 34,
    fill: "#2563eb",
    fontWeight: 700
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 14,
    fill: "#35556b"
  }, "Monitor"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(540,40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 68,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 34,
    fill: "#2563eb",
    fontWeight: 700
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 14,
    fill: "#35556b"
  }, "Report"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 100 h60",
    stroke: "#a6c4da",
    strokeWidth: 6,
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440 100 h60",
    stroke: "#a6c4da",
    strokeWidth: 6,
    markerEnd: "url(#arrow)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 10,
    markerHeight: 10,
    refX: 10,
    refY: 5,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#a6c4da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.379d72e7c6b4ba5489eb0b73c2b8c52c.svg";
export { ForwardRef as ReactComponent };